export default __webpack_public_path__ + "static/media/logo-tauromarkets-white2.4aecafa1.svg";